module.exports = __webpack_public_path__ + "img/en.6f382b2d.png";